import { THEME } from 'GlobalStyles';

export const styles = {
  container: {
    height: '100%'
  },
  TabContent: {
    padding: 0,
    backgroundColor: THEME.palette.grey[50]
  },
  TabInventory: {
    height: 'calc(100vh - 138px)' /** TODO Check layout */,
    backgroundColor: THEME.palette.grey[50]
  }
};
